import React from 'react';

// This function takes a component...
export function withDataCapture(WrappedComponent, selectData) {
    // ...and returns another component...
    return class extends React.Component {
        constructor(props) {
            super(props);
            this.handleDataCapture = this.handleDataCapture.bind(this);
            this.buildApiData = this.buildApiData.bind(this);
            this.state = {
                loading: false,
                responseReceived: false,
                data: {},
                errors: {}
            };
        }

        buildApiData(obj) {
            if (!obj) {
                return [];
            }

            return Object.keys(obj).map(key => ({
                "key": key,
                "value": obj[key].toString()
            }))
        }

        handleDataCapture(result, emailAddress, addressBookId) {
            const dataCapture = {
                "emailAddress": emailAddress,
                "addressBookID": addressBookId,
                "apiData": this.buildApiData(result)
            };

            this.setState({ loading: true }, () => {
                fetch('/api/sitecore/DataCollection/SendDataCapture', {
                    method: 'POST',
                    headers: { 'content-type': 'application/json' },
                    body: JSON.stringify(dataCapture)
                })
                    .then((response) => {
                        this.setState({
                            loading: false,
                            responseReceived: true,
                            succeeded: response.ok
                        })
                    })
                    .catch((error) => {
                        this.setState({
                            loading: false,
                            responseReceived: true,
                            succeeded: false
                        })
                    });
            })
        }

        render() {
            const { succeeded, loading, responseReceived } = this.state;
            return <WrappedComponent
                succeeded={succeeded} loading={loading} responseReceived={responseReceived} handleDataCapture={this.handleDataCapture} {...this.props} />;
        }
    };
}